// #region imports

// --- Angular
import { Component, EventEmitter, Inject } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';

// --- RxJs

// --- 3rd Party

// --- HS Code
import {
  RespondentOptionsBottomSheetInput,
  RespondentOptionsBottomSheetOutput,
} from './respondent-options-bottom-sheet.model';
import {
  ManageRespondentDropdownStates,
  RespondentModel,
  RespondentStatuses,  
} from 'src/app/models';

// #endregion

@Component({
  selector: 'hs-respondent-options-bottom-sheet.ts',
  templateUrl: './respondent-options-bottom-sheet.component.html',
  styleUrls: ['./respondent-options-bottom-sheet.component.scss'],
})
export class RespondentOptionsBottomSheetComponent {
  editMessageClicked = new EventEmitter();
  deleteClicked = new EventEmitter();
  moveRespondentClick = new EventEmitter<{
    respondent: RespondentModel;
    targetGroup: any;
  }>();

  updateManageRespondentDropdownState =
    new EventEmitter<ManageRespondentDropdownStates>();

  remindRespondentClick = new EventEmitter<RespondentModel>();
  readonly respondentStatuses = RespondentStatuses;


  get hasEditButton() {

    return this.data.buttons.some((button) => button === 'edit');
  }

  get hasMoveButton() {
    return this.data.buttons.some((button) => button === 'move');
  }

  get hasDeleteButton() {
    return this.data.buttons.some((button) => button === 'delete');
  }

  constructor(
    private _bottomSheetRef: MatBottomSheetRef<
      RespondentOptionsBottomSheetComponent,
      RespondentOptionsBottomSheetOutput
    >,
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: RespondentOptionsBottomSheetInput
  ) {}

  onMoveRespondentClick(respondent: RespondentModel, targetGroup: any) {
    this.moveRespondentClick.emit({ respondent, targetGroup });
  }

  onDeleteClicked() {
    this.deleteClicked.emit();
  }

  onEditMessageClicked() {
    this.editMessageClicked.emit();
  }

  onUpdateManageRespondentDropdownState(state: ManageRespondentDropdownStates) {
    this.updateManageRespondentDropdownState.emit(state);
  }

  closeIconClick() {
    this._bottomSheetRef.dismiss();
  }

  onSendReminderClick(respondent: RespondentModel): void {
    respondent.canResendEmail = false;
    const now = new Date();
    respondent.lastEmailSentDate = new Date(
      Date.UTC(
        now.getFullYear(),
        now.getMonth() + 1,
        now.getDay(),
        now.getHours(),
        now.getMinutes()
      )
    ).toString();
    this.remindRespondentClick.emit(respondent);
  }
}
